export default __webpack_public_path__ + "static/media/NB-IOT-CO2.641a48e6.png";